export default "__VITE_ASSET__iq60uQDy__"